import { pageSizes } from './constants'
import { Stack, Button, AppBar, Toolbar, Grid, Box } from '@mui/material'
import AppLogo from '../../images/PhotoBridge_Logo_white-on-red.svg'
import apiConfig from '../../apiConfig'

export default function PreviewHeader(props) {
  const {
    classes = {},
    onButtonClick = () => {},
    pageSize = '',
    showWorkflowFlyout = () => {},
    viewMode = 'preview',
    onViewModeChange = () => {},
  } = props
  return (
    <AppBar position="fixed" style={{ width: '100%', background: '#CC0000' }}>
      <Toolbar>
        <Grid wrap={'nowrap'} container alignItems={'center'}>
          <Grid
            lg="8"
            wrap={'nowrap'}
            container
            item
            direction={'row'}
            alignItems={'center'}
          >
            <Grid>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <AppLogo title="Application Logo" />
                <span
                  style={{
                    color: '#FFF',
                    fontFamily: 'Roboto',
                    fontSize: '20px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    marginLeft: 24,
                  }}
                >
                  PhotoBridge - Advanced Preview
                </span>
              </div>
            </Grid>
            <Grid
              style={{
                borderLeft: '2px solid #ffffff',
                borderRight: '2px solid #ffffff',
                margin: '0 24px',
              }}
            >
              <Stack
                direction="row"
                justifyContent={'space-evenly'}
                style={{
                  margin: '0 24px',
                }}
              >
                {pageSizes.map((dat, i) => {
                  return (
                    <Button
                      key={dat.size || i}
                      classes={{
                        root: classes.button,
                        outlined: classes.outlinedButton,
                        contained: classes.containedButton,
                      }}
                      variant={
                        viewMode === 'preview' && pageSize === dat.size
                          ? 'contained'
                          : 'outlined'
                      }
                      onClick={() => onButtonClick(dat.size)}
                    >
                      {dat.label}
                    </Button>
                  )
                })}
                <Box style={{ position: 'relative' }}>
                  <Button
                    classes={{
                      root: classes.button,
                      outlined: classes.outlinedButton,
                      contained: classes.containedButton,
                    }}
                    variant={
                      viewMode === 'annotation' ? 'contained' : 'outlined'
                    }
                    onClick={() => onViewModeChange('annotation')}
                  >
                    {'Mark up'}
                  </Button>
                  <Box
                    style={{
                      position: 'absolute',
                      top: -4,
                      right: -4,
                      background: '#fff',
                      color: '#cc0000',
                      fontSize: '8px',
                      fontWeight: 700,
                      padding: '2px 4px',
                      borderRadius: '4px',
                      lineHeight: 1,
                      pointerEvents: 'none',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                    }}
                  >
                    NEW
                  </Box>
                </Box>
              </Stack>
            </Grid>
          </Grid>
          <Grid lg="4">
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              {!apiConfig.isPol && (
                <Button
                  classes={{
                    root: classes.button,
                    outlined: classes.outlinedButton,
                    contained: classes.containedButton,
                  }}
                  variant={'contained'}
                  onClick={() => showWorkflowFlyout()}
                >
                  {'Show Workflow'}
                </Button>
              )}
            </Stack>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  )
}
